import {
    AttestationHistoryColumns,
    AttestationHistoryTableConfiguration,
} from '@core/configs/tables/dashboard/attestation-history-table.config';
import { useFetch } from '@core/utils/hooks/use-fetch';
import Table from '@shared/components/tables';
import { html, nothing } from '@shared/utils/rendering/html';
import { useMemo } from 'preact/hooks';
import { useHistoryData } from './hooks/use-history-data';
import { useHistoryFilters } from './hooks/use-history-filters';

const AttestationHistoryTable = ({ recordId }) => {
    const { requestParams, tableFilters } = useHistoryFilters();
    const { tableData } = useHistoryData(recordId, requestParams);

    const config = useMemo(() => {
        return {
            columns: AttestationHistoryColumns,
            filters: tableFilters,
            actions: null,
            collapse: AttestationHistoryTableConfiguration.collapse,
        };
    }, [tableFilters]);

    return config ? html` <${Table} config=${config} data=${tableData} /> ` : nothing;
};

export default AttestationHistoryTable;
